module.exports = __webpack_public_path__ + "img/20220624164606.499df1b0.png";